import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  CCard, CCardBody, CCardHeader, CButton, CSpinner, CAlert, CRow, CCol,
} from '@coreui/react';
import api from '../../services/api';
import { downloadPdf } from '../../services/financeDownload';

export default function PaymentReceiptPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get(`/finance/payments/${id}`)
      .then((r) => setData(r.data))
      .catch(() => setError('Payment not found.'));
  }, [id]);

  if (error) return <CAlert color="danger">{error}</CAlert>;
  if (!data) return <div className="text-center py-5"><CSpinner color="success" /></div>;

  const { payment, invoice, job, customer } = data;

  return (
    <div className="receipt-print">
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3 no-print">
        <CButton color="secondary" variant="outline" size="sm" component={Link} to="/finance/payments">← Payment history</CButton>
        <span>
          <CButton color="success" variant="outline" size="sm" className="me-2" onClick={() => window.print()}>Print</CButton>
          <CButton color="success" size="sm" onClick={() => downloadPdf(`/finance/payments/${id}/pdf`, `PAY-${id}.pdf`).catch(() => {})}>Download PDF</CButton>
        </span>
      </div>

      <CCard className="border shadow-sm" style={{ borderRadius: 8, maxWidth: 640, margin: '0 auto' }}>
        <CCardHeader className="bg-white py-4 text-center">
          <h4 className="mb-0">Payment receipt</h4>
          <div className="text-muted small mt-1">PAY-{payment.id}</div>
        </CCardHeader>
        <CCardBody className="p-4">
          <CRow className="g-3 small mb-3">
            <CCol xs={6}>
              <div className="text-muted text-uppercase" style={{ fontSize: 10 }}>Paid at</div>
              <div>{String(payment.paid_at || '').replace('T', ' ').slice(0, 19)}</div>
            </CCol>
            <CCol xs={6}>
              <div className="text-muted text-uppercase" style={{ fontSize: 10 }}>Recorded by</div>
              <div>{payment.recorded_by}</div>
            </CCol>
            <CCol xs={12}>
              <div className="text-muted text-uppercase" style={{ fontSize: 10 }}>Invoice</div>
              <div>
                <Link to={`/finance/invoices/${invoice?.id}`} className="no-print">{invoice?.invoice_no}</Link>
                <span className="d-none d-print-inline">{invoice?.invoice_no}</span>
              </div>
            </CCol>
            <CCol xs={12}>
              <div className="text-muted text-uppercase" style={{ fontSize: 10 }}>Job</div>
              <div>{job?.jobcode} (ID {job?.jid})</div>
            </CCol>
            {customer?.nama && (
              <CCol xs={12}>
                <div className="text-muted text-uppercase" style={{ fontSize: 10 }}>Customer</div>
                <div>{customer.nama}</div>
              </CCol>
            )}
          </CRow>

          <div className="border rounded p-4 text-center bg-light">
            <div className="text-muted small text-uppercase mb-1">Amount received</div>
            <div className="display-6 fw-bold text-success">RM {Number(payment.amount).toFixed(2)}</div>
          </div>

          {payment.note && (
            <div className="mt-3 small text-muted">Note: {payment.note}</div>
          )}
        </CCardBody>
      </CCard>

      <style>{`
        @media print {
          .no-print { display: none !important; }
          .receipt-print .card { border: none !important; box-shadow: none !important; }
        }
      `}</style>
    </div>
  );
}
